import { defineMessages } from 'react-intl'

export const i18n = defineMessages({
  error: {
    id: 'step_2.errors.global_error',
  },
})
